import { Component, OnInit } from '@angular/core';
import { EncounterFilter, EncounterService } from '../../../services/encounter.service';
import { EncounterFinancials, TealCompEncounter, TealCompEncounterHeader } from '../../../models/encounter';
import { TableModule, TableRowSelectEvent, TableRowUnSelectEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { AsyncPipe, CurrencyPipe, DatePipe, NgClass, NgIf } from '@angular/common';
import { Bill, Invoice } from '../../../models/finance';
import { FinanceService } from '../../../services/finance.service';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { PanelModule } from 'primeng/panel';
import { EmailService, ErrorMessage, IDraftEmail,EmailComposerComponent, BlockUI } from '@harlowe/core'
import { TooltipModule } from 'primeng/tooltip';
import { lastValueFrom, Observable } from 'rxjs';
import { UtilService } from '@harlowe/core';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuItem } from 'primeng/api';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { DialogModule } from 'primeng/dialog';
import { Store } from '@ngxs/store';
import { EncounterEmailHandler } from '../../encounter/encounter-editor/encounter-email-handler';
import { ClaimService } from '../../../services/claim.service';
import { ReferralService } from '../../../services/referral.service';

@Component({
  selector: 'app-encounter-billing',
  standalone: true,
  imports: [TableModule, ButtonModule,CurrencyPipe,DatePipe,
            CheckboxModule,CalendarModule, FormsModule, FloatLabelModule,
            NgIf, PanelModule, NgClass, TooltipModule, SplitButtonModule,
            EmailComposerComponent, ButtonGroupModule,DialogModule,
            AsyncPipe, TooltipModule
  ],
  templateUrl: './encounter-billing.component.html',
  styleUrl: './encounter-billing.component.scss',
})
export class EncounterBillingComponent implements OnInit
{

  encountersToInvoice: TealCompEncounterHeader[] = [];
  processedFinancials : EncounterFinancials[] = [];
  processedEncounterHandlers : {[encounterId:number]:EncounterEmailHandler} = {};
  // processedEncounters: TealCompEncounterHeader[] = [];
  // foundInvoices:Invoice[] = [];
  // foundBills:Bill[]= [];

  get processedEncounters(): TealCompEncounterHeader[]
  {
    return this.processedFinancials.map(f => f.encounter);
  }

  get foundInvoices () : Invoice[]
  {
    return this.processedFinancials.map(f => f.invoice);
  }

  get foundBills () : Bill[]
  {
    return this.processedFinancials.flatMap(f => f.bills);
  }

  searchAfter?: Date;
  searchBefore?: Date; 
  includeComplete: boolean = false;

  selectedEncounters: TealCompEncounterHeader[] = [];
  processingStatus: {[encounterId:number]:boolean} = {};
  unProcessingStatus: {[encounterId:number]:boolean} = {};
  errorStatus: {[encounterId:number]:ErrorMessage} = {};
  packageEmailDialogVisible: {[encounterId:number]:boolean} = {};
  processing: boolean = false;
  searchingEncounters: boolean = false;

  //Table Selection Models
  selectedProcessedEncounter?: TealCompEncounterHeader;
  selectedProcessedBills: Bill[] = [];
  selectedProcessedInvoice? : Invoice;

  //Split Button Options
  packageOptions: {[encounterId:number]:MenuItem[]} = {};
  draftEmail?:IDraftEmail;
  encounters: {[encounterId:number]:Observable<TealCompEncounter>} = {};
  e?: TealCompEncounter;

  


  constructor
  (
    private _encounterService: EncounterService,
    private _financeService: FinanceService,
    private _utilService: UtilService,
    private _store:Store,
    private _emailService: EmailService,
    private _claimsService: ClaimService,
    private _referralService: ReferralService
  )
  {
 
  }


  ngOnInit(): void 
  {
    this.searchEncounters(); 
  }

  async searchEncounters()
  {
    this._store.dispatch(new BlockUI.BlockUI());

    this.searchingEncounters = true;
    this.processing = true;
    var filter1 = new EncounterFilter();
    filter1.statuses = [5];
    filter1.includeUnassigned = true;
    await this._encounterService.searchForEncounters(filter1).then(encounters => this.encountersToInvoice = Array.from(encounters.values()).map(e => e.encounter as TealCompEncounterHeader));
    this.processing = false;
    this.searchingEncounters = false;
    this._store.dispatch(new BlockUI.UnBlockUI());

  }


  async refreshPackageOptions()
  {
    //Set up menu items
    this.processedFinancials.forEach
    (
      f =>
      {
        this.packageOptions[f.encounter.id] = [{
          label: 'Print',
          icon: 'pi pi-print',
          command: () => 
          {
            this.downloadPayerPackage(f.encounter);
          }
        }]
      }
    ) 
  }

  async searchFinancials()
  {
    this._store.dispatch(new BlockUI.BlockUI());

    var ef = await this._encounterService.searchEncounterFinancials(this.searchAfter,this.searchBefore,this.includeComplete)

    this.processedEncounterHandlers = [];
    
    for (const f of ef)
    {
      const handler = await this.buildHandler(f.encounter);
      handler.create(0);
      this.processedEncounterHandlers[f.encounter.id] = handler;
    }
    

    this.processedFinancials = ef;

    await this.refreshPackageOptions();
    this._store.dispatch(new BlockUI.UnBlockUI());



  }

  async viewPayerBill(encounter:TealCompEncounterHeader)
  {
    this._store.dispatch(new BlockUI.BlockUI());
      //Get the encounter
      var enc = await lastValueFrom(this._encounterService.getEncounter(encounter.id));
      if(enc.payerMedicalBillImage)
      {
        var blob = await this._utilService.getFileBlob(enc.payerMedicalBillImage);
        let url = window.URL.createObjectURL(blob);
          let pwa = window.open(url);
      }
    this._store.dispatch(new BlockUI.UnBlockUI());
  }

  async downloadPayerPackage(encounter:TealCompEncounterHeader)
  {
    this._store.dispatch(new BlockUI.BlockUI());

    //Get the encounter
    if(encounter)
    {
      var blob = await this._encounterService.downloadPayerInvoicePackage(encounter.id);
      let url = window.URL.createObjectURL(blob);
        let pwa = window.open(url);
    }
    this._store.dispatch(new BlockUI.UnBlockUI());

  }

  async unProcessEncounter(encounter:TealCompEncounterHeader)
  {
    this._store.dispatch(new BlockUI.BlockUI());

    this.unProcessingStatus[encounter.id] = true;
    this.processing = true;

    await this._encounterService.unProcessEncounterFinancials(encounter.id)
      .then
      (
        //Clear out the invoice and bills that were associated
        async ef =>
        {
          // //Bills
          // ef.bills.forEach
          // (
          //   b=>
          //     {
          //       var index = this.foundBills.findIndex(fb => fb.id == b.id);
          //       this.foundBills.splice(index,1);
          //     }
          // )
          
          // //Invoice
          // var index = this.foundInvoices.findIndex(fi => fi.id == ef.invoice.id);
          // this.foundInvoices.splice(index,1);

          // //Encounter
          // var eIndex = this.processedEncounters.findIndex(pe => pe.id == ef.encounter.id);
          // this.processedEncounters.splice(eIndex,1);
          var index = this.processedFinancials.findIndex(pf => pf.encounter.id == ef.encounter.id);
          this.processedFinancials.splice(index,1);

          //Put the encounter we just unprocssed back into the list to process
          this.encountersToInvoice = this.encountersToInvoice.concat(encounter);

          delete this.unProcessingStatus[encounter.id];
          this.processing = false;
          await this.refreshPackageOptions();
          this._store.dispatch(new BlockUI.UnBlockUI());


        }
      )
      .catch
      (
        error =>
        {
          this._store.dispatch(new BlockUI.UnBlockUI());
        }
      );
  }

  async processSelectedEncounters()
  {
    this._store.dispatch(new BlockUI.BlockUI());

    this.processing = true;

    //Process each encounter
    var encounterProcessTasks = this.selectedEncounters.map
    (
      e => 
      {
        //Set the row in the table as processing
        this.processingStatus[e.id] = true;
        delete this.errorStatus[e.id];

        //Process
        return this._encounterService.processEncounterFinancials(e.id)
          .then
          (
            async ef => 
            {
              //Stop processing
              this.processingStatus[e.id] = false;

              //Remove from the 'to process' list
              var index= this.encountersToInvoice.findIndex(ie => ie.id == e.id );
              var removedEnc = this.encountersToInvoice.splice(index,1);

              //Remove from selected
              var selectedIndex = this.selectedEncounters.findIndex(ie => ie.id == e.id );
              this.selectedEncounters.splice(selectedIndex,1);

              //Add to the processed list. We use expansion, but there should only be one item to add
              // this.processedEncounters = this.processedEncounters.concat(... removedEnc);
              this.processedFinancials = [... this.processedFinancials, ef];

              // //Add bills and invoices to the list
              // this.foundBills = this.foundBills.concat(... ef.bills);
              // this.foundInvoices = this.foundInvoices.concat(ef.invoice);
              await this.refreshPackageOptions();
              this._store.dispatch(new BlockUI.UnBlockUI());
              
            }
          )
          .catch
          (
            error =>
              {
                this.processingStatus[e.id] = false;
                //Log this one as an error
                this.errorStatus[e.id]=error;
                console.log(error);
                this._store.dispatch(new BlockUI.UnBlockUI());

              }
          )
      }
    );

    //Wait for everything to process
    await Promise.all(encounterProcessTasks);

    this.processing = false;

  }

  processedEncounterSelected(event:TableRowSelectEvent)
  {
    var enc = event.data as TealCompEncounterHeader;

    this.selectedProcessedBills = this.processedFinancials.find(f => f.encounter.id == enc.id)?.bills ?? [];
    this.selectedProcessedInvoice = this.processedFinancials.find(f => f.encounter.id == enc.id)?.invoice;
    this.selectedProcessedEncounter = this.processedFinancials.find(f => f.encounter.id == enc.id)?.encounter;
  }

  processedEncounterUnselected(event:TableRowUnSelectEvent)
  {
    this.selectedProcessedBills = [];
    this.selectedProcessedEncounter = undefined;
    this.selectedProcessedInvoice = undefined;
  }

  processedBillSelected(event:TableRowSelectEvent)
  {
    var bill = event.data as Bill;
    var enc = this.processedFinancials.find(f => f.bills.map(b => b.id).includes(bill.id))?.encounter;

    if(enc)
    {
      this.selectedProcessedBills = this.processedFinancials.find(f => f.encounter.id == enc?.id)?.bills ?? [];
      this.selectedProcessedInvoice = this.processedFinancials.find(f => f.encounter.id == enc?.id)?.invoice;
      this.selectedProcessedEncounter = this.processedFinancials.find(f => f.encounter.id == enc?.id)?.encounter;
    }
  }

  processedBillUnselected(event:TableRowUnSelectEvent)
  {
    this.selectedProcessedBills = [];
    this.selectedProcessedEncounter = undefined;
    this.selectedProcessedInvoice = undefined;
  }

  processedInvoiceSelected(event:TableRowSelectEvent)
  {
    var inv = event.data as Invoice;
    var enc = this.processedFinancials.find(f => f.invoice.id == inv.id)?.encounter;

    if(enc)
    {
      this.selectedProcessedBills = this.processedFinancials.find(f => f.encounter.id == enc?.id)?.bills ?? [];
      this.selectedProcessedInvoice = this.processedFinancials.find(f => f.encounter.id == enc?.id)?.invoice;
      this.selectedProcessedEncounter = this.processedFinancials.find(f => f.encounter.id == enc?.id)?.encounter;
    }
  }

  processedInvoiceUnselected(event:TableRowUnSelectEvent)
  {
    this.selectedProcessedBills = [];
    this.selectedProcessedEncounter = undefined;
    this.selectedProcessedInvoice = undefined;
  }

  async newDraftEmail(encounter:TealCompEncounterHeader)
  {
    this.draftEmail = {} as IDraftEmail
    this.draftEmail.recipients = [];
    // this.encounters[encounter.id] = this._encounterService.getEncounter(encounter.id);
    // this.encounters[encounter.id].subscribe(v => console.log(v));
    this.e = await lastValueFrom(this._encounterService.getEncounter(encounter.id));
  }



  async sendEmailPackage(draftEmail: IDraftEmail, encounter: TealCompEncounterHeader)
  {
    this._store.dispatch(new BlockUI.BlockUI());

    if(encounter && draftEmail)
    {
      await this._encounterService.emailPayerInvoicePackage(encounter.id,draftEmail);
      this.packageEmailDialogVisible[encounter.id] = false;
    }
    this._store.dispatch(new BlockUI.UnBlockUI());

  }

  getExtraInfo(encounter: TealCompEncounterHeader)
  {
    return 'Insured name: ' +  encounter.party + '\nService Date: ' + encounter.serviceDate?.toString();
  }

  cancelEmail()
  {
    this.draftEmail = undefined;
  }

  allowSend() : boolean
  {
    return this.draftEmail != null && this.draftEmail.recipients != null  && 
            this.draftEmail.recipients.length > 0 && this.draftEmail.subject != null && 
            this.draftEmail.body != null && this.draftEmail.from != null
  }

  async buildHandler(encounter: TealCompEncounterHeader) : Promise<EncounterEmailHandler>
  {
    var enc = await lastValueFrom(this._encounterService.getEncounter(encounter.id));
    return new EncounterEmailHandler(enc,this._emailService,this._encounterService, this._referralService,this._claimsService,this._store);
  }

}
